import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[dragNDropDirective]',
  standalone: false,
})
export class DragNDropDirective implements OnInit {
  @Input() defaultClasses!: string;

  @Input() onDragOverClasses!: string;

  @Output() dropped = new EventEmitter<string>();

  constructor(
    private readonly _renderer: Renderer2,
    private readonly _element: ElementRef,
  ) {}

  ngOnInit() {
    this._renderer.addClass(this._element.nativeElement, this.defaultClasses);
  }

  @HostListener('dragover', ['$event']) public onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this._renderer.removeClass(this._element.nativeElement, this.defaultClasses);
    this._renderer.addClass(this._element.nativeElement, this.onDragOverClasses);
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this._renderer.removeClass(this._element.nativeElement, this.onDragOverClasses);
    this._renderer.addClass(this._element.nativeElement, this.defaultClasses);
  }

  @HostListener('drop', ['$event']) public onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this._renderer.removeClass(this._element.nativeElement, this.onDragOverClasses);
    this._renderer.addClass(this._element.nativeElement, this.defaultClasses);
    this.dropped.emit(event.dataTransfer?.getData('text/plain'));
  }
}
